import { render } from "./HeaderCell.vue?vue&type=template&id=488ec273"
import script from "./HeaderCell.vue?vue&type=script&lang=js"
export * from "./HeaderCell.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__